import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useMessage } from '../contexts/MessageContext';
import { useAuth  } from '../contexts/AuthContext';
import {Table} from './common/Table';
import {Loading} from './common/Loading';

const apiUrl = window._env_?.REACT_APP_API_URL || "https://app.mylocaleventrentals.com/api";

const InvoiceList = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const { logout, getToken } = useAuth();
  const navigate = useNavigate();
  const token = getToken ? getToken() : localStorage.getItem('token');
  const {  showError } = useMessage();
  useEffect(() => {
    if (!token) {
      logout();
      navigate('/login');
    }
  }, [token, logout, navigate]);

  const columns = [
    { key: 'invoiceNumber', label: 'Invoice #', sortable: true },
    {
      key: 'customer',
      label: 'Customer Name',
      sortable: false,
      render: (value, row) => {
        // Show full name if available
        return row.Customer ? `${row.Customer.firstname} ${row.Customer.lastname}` : '-';
      }
    },
    {
      key: 'total_amount',
      label: 'Total Amount',
      sortable: true,
      render: (value) => `$${parseFloat(value).toFixed(2)}`
    },
    {
      key: 'status',
      label: 'Status',
      sortable: false,
      render: (value) => (
        <span className={`px-2 py-1 rounded text-xs ${
          value === 'paid' ? 'bg-green-100 text-green-800' :
          value === 'pending' ? 'bg-yellow-100 text-yellow-800' :
          'bg-red-100 text-red-800'
        }`}>
          {value}
        </span>
      )
    },
    {
      key: 'actions',
      label: 'Actions',
      sortable: false,
      render: (_, row) => (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/invoice/${row.uuid}/edit`);
          }}
          className="text-blue-600 hover:text-blue-800 text-xs underline whitespace-nowrap"
        >
          Edit
        </button>
      )
    }
  ];

  // Fetch invoices
  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const res = await axios.get(apiUrl + "/invoice", {
          headers: { "x-auth-token": token }
        });
        setInvoices(res.data.data || res.data); // Adjust based on your API
        setLoading(false);
      } catch (err) {
        showError(
          err?.response?.data?.message ||
          err?.message ||
          'Failed to fetch invoices'
        );
        setLoading(false);
      }
    };
    fetchInvoices();
  }, [token, showError]);
const handleDetails = (id) => {
  navigate(`/invoice/${id}`); // if you want to redirect
};
  if (loading) {
    return <Loading />;
  }

  return (
    <div className="p-4 md:p-6 my-2 md:my-6 bg-white shadow-lg rounded-lg">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800">All Invoices</h2>
        <button
          type="button"
          onClick={() => navigate('/invoice/new')}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 font-medium text-sm"
        >
          + New Invoice
        </button>
      </div>
      <Table
        columns={columns}
        data={invoices}
        striped={true}
        hoverable={true}
        onRowClick={(row) => handleDetails(row.uuid)}
        paginated={true}
        pageSize={10}  // Show 10 items per page
        rowKey="uuid"  // Add this line - tells Table to use 'uuid' instead of 'id'
      />
    </div>
  );
};

export default InvoiceList;
